import { useTranslation } from "react-i18next";
import { LayoutTitle } from "../_layout/index.react";
import { useSupport } from "@/features/support/hooks/use-support";
import Loader from "@/atoms-react/loader/Loader.react";
import { twMerge } from "tailwind-merge";
import { Base } from "@/atoms-react/text/Text.react";

export const SupportApp = () => {
  const { t } = useTranslation(["pass"]);
  const { SupportUrl } = useSupport();
  const { data: url, isError } = SupportUrl();

  return (
    <>
      <LayoutTitle>
        <div className="flex items-center gap-x-2">{t("support.label.main_title")}</div>
      </LayoutTitle>

      <div className="relative flex h-full w-full flex-col gap-y-6 md:flex-col md:gap-x-6 2xl:flex-row">
        <Loader
          className={twMerge(
            "absolute top-1/2 left-1/2 text-gray-500 transition-opacity",
            url ? "opacity-0" : "opacity-100"
          )}
        />
        <div
          className={twMerge(
            "h-full w-full transition-opacity",
            url ? "opacity-100" : "opacity-0"
          )}
        >
          {url && (
            <iframe
              className="h-full w-full rounded-xl border-2 dark:border-slate-700"
              src={url}
              sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
          )}
        </div>
        {isError && (
          <div className="absolute top-0 right-0 bottom-0 left-0 m-auto h-5 w-full max-w-md text-center">
            <Base className="animate__animated animate__fadeIn animate__faster mt-4 block">
              {t("olkypass.supportPage.error")}
            </Base>
          </div>
        )}
      </div>
    </>
  );
};
